<div class="play-pause">

  <button mat-raised-button class="play-pause-icon from" (click)="play()">
    <img class="action" src="/assets/icons/play.svg" alt="play icon" />
  </button>

</div>